module.exports = __webpack_public_path__ + "5d4140f2321a2b5be67f567ad48de349.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont/iconfont.ttf?t=1462848962
// module id = 1050
// module chunks = 75